/* This JavaScript code snippet is importing the Axios library, setting a default configuration for
Axios to include credentials in cross-origin requests, and creating an Axios instance with a
specified base URL. */

import axios from "axios";
import Cookies from "js-cookie";

axios.defaults.withCredentials = true;

const Axios = axios.create({
  // baseURL: document.getElementById("API_URL").value, // Use this for local development
  // baseURL: "http://localhost:3003", // Use this for local development
  // baseURL: "https://backend.dts-erp.com", // Use this for live production
  baseURL: "https://backend.dts.leadboat.in", // Use this for live production
  // baseURL: "https://api.test.rabsconnect.in", // Use this for live production
  // baseURL: "https://backend.durlax.rabs.support", // Use this for demo production
});

// The backend answers 401 when the server-side session has expired (it lasts 30 days,
// the login cookies 365). Clear the login cookies and send the user back to the login screen.
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && localStorage.getItem("currScreen") !== "Login") {
      ["u_id", "ccode", "mobile_no", "role", "type", "token", "module_privilege", "user", "username"].forEach(
        (name) => Cookies.remove(name, { path: "/", domain: window.location.hostname })
      );
      localStorage.setItem("currScreen", "Login");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default Axios;
